import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatError(err) {
  const d = err?.response?.data?.detail ?? err?.message ?? "Something went wrong.";
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d === "object" && d?.msg) return d.msg;
  return typeof d === "string" ? d : JSON.stringify(d);
}
